import {
  URL_CATEGORIA,
  URL_CLASIFICACION_PRODUCTO,
  URL_FAMILIA, URL_MARCA_PRODUCTO, URL_PRODUCTO_CORRELATIVO, URL_PRODUCTO_MIRANDA,
  URL_VEHICULO_MARCA, URL_VEHICULO_MODELO, URL_VEHICULOS
} from "../../../api/config";
import makeQuery from "../../../api/helper";
import {uuid} from "vue-uuid";

const defaultState = () => {
  return {
    isLoadingVehiculos: false,
    isLoading: false,
    marcasVehiculos: [],
    categorias: [],
    familias: [],
    clasificaciones: [],
    marcasProducto: [],
    esPrimario: "",
    producto: {
      id: uuid.v4(),
      codigo: "XXXXXXXXX",
      estado: "activo",
      descripcion: "",
      numero_parte: "",
      marca: "",
      categoria: "",
      familia: "",
      clasificacion: "",
      marcaProducto: "",
      medida: "",
      pais: "",
      grupo: "E",
      observacion: "",
      vehiculosCompatibles: [],
      imagenes: [],
      descripcionWeb: "",
      descripcionCortaWeb: "",
      nombreWeb: "",
      flagWeb: false,
      precioWeb: 0
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    "RESET_STATE"(state) {
      Object.assign(state, defaultState())
    },
    "SET_KEY_PRODUCTO"(state, payload) {
      state.producto[payload.key] = payload.value
    },
    "SET_MARCAS_VEHICULOS"(state, payload) {
      state.marcasVehiculos = payload
    },
    "SET_CATEGORIAS"(state, payload) {
      state.categorias = payload
    },
    "SET_FAMILIAS"(state, payload) {
      state.familias = payload
    },
    "SET_CLASIFICACIONES"(state, payload) {
      state.clasificaciones = payload
    },
    "SET_MARCAS_PRODUCTO"(state, payload) {
      state.marcasProducto = payload
    },
    "SET_PRODUCTO_VEHICULO_COMPATIBLE"(state, payload) {
      state.producto.vehiculosCompatibles.push(payload)
    },
    "ELIMINAR_PRODUCTO_VEHICULO_COMPATIBLE"(state, payload) {
      state.producto.vehiculosCompatibles.splice(payload, 1)
    },
    "SET_KEY_VEHICULO_COMPATIBLE"(state, payload) {
      state.producto.vehiculosCompatibles[payload.index][payload.key] = payload.data
    },
    "SET_PRODUCTO_EDIT"(state, payload) {
      state.producto = {...payload}
    },
    "SET_LOADING"(state, payload) {
      state.isLoading = payload
    },
    "LOAD_VEHICULOS"(state, payload) {
      state.isLoadingVehiculos = payload
    },
    "RESET_ALL_CHECKED"(state) {
      state.producto.vehiculosCompatibles.forEach(item => {
        item.esPrimario = false
      })
    },
    "SET_IMAGENES"(state, payload) {
      state.producto.imagenes = payload
    },
    "DELETE_IMAGE"(state, payload) {
      state.producto.imagenes.splice(payload, 1)
    }
  },
  actions: {
    async getMarcas({commit, dispatch}) {
      try {
        const response = await this._vm.$axios.get(URL_VEHICULO_MARCA)
        const array = await dispatch("ordenarArray", {array: response.data.items, key: "nombre"})
        commit("SET_MARCAS_VEHICULOS", array.filter(item => item.estado !== "inactivo"))
      } catch (e) {
        console.error(e, "failed to load marcas")
      }
    },
    async getCategorias({commit, dispatch}) {
      try {
        const response = await this._vm.$axios.get(URL_CATEGORIA)
        const array = await dispatch("ordenarArray", {array: response.data.items, key: "nombre"})
        commit("SET_CATEGORIAS", array)
      } catch (e) {
        console.error(e, "failed to load categorias")
      }
    },
    async getFamilias({commit, dispatch}, payload) {
      try {
        const query = await dispatch("crearQuery", payload)
        const response = await this._vm.$axios.get(URL_FAMILIA + query)
        const array = await dispatch("ordenarArray", {array: response.data.items, key: "nombre"})
        commit("SET_FAMILIAS", array.filter(item => item.estado !== "inactivo"))
      } catch (e) {
        console.log(e, "failed to load familia")
      }
    },
    async getClasificacion({commit, dispatch}, payload) {
      try {
        const query = await dispatch("crearQuery", payload)
        const response = await this._vm.$axios.get(URL_CLASIFICACION_PRODUCTO + query)
        const array = await dispatch("ordenarArray", {array: response.data.items, key: "nombre"})
        commit("SET_CLASIFICACIONES", array.filter(item => item.estado !== "inactivo"))
      } catch (e) {
        console.error(e, "failed to load clasificacion")
      }
    },
    async getMarcaProducto({commit, dispatch}) {
      try {
        const response = await this._vm.$axios.get(URL_MARCA_PRODUCTO)
        const array = await dispatch("ordenarArray", {array: response.data.items, key: "nombre"})
        commit("SET_MARCAS_PRODUCTO", array.filter(item => item.estado !== "inactivo"))
      } catch (e) {
        console.error(e, "failed to load marca producto")
      }
    },
    async getModeloVehiculo({commit, dispatch}, payload) {
      try {
        const query = makeQuery({
          filtros: [{field: 'vehiculo_marca_id', value: payload.data.id, operator: '='}]
        })
        const response = await this._vm.$axios.get(URL_VEHICULO_MODELO + query)
        const array = await dispatch("ordenarArray", {array: response.data.items, key: "nombre"})
        commit("SET_KEY_VEHICULO_COMPATIBLE", {index: payload.index, key: "modelos", data: array})
      } catch (e) {
        console.error(e, "failed to load modelo vehiculo")
      }
    },
    async getVehiculos({commit, state}, payload) {
      try {
        const {marca, modelo} = state.producto.vehiculosCompatibles[payload.index]
        const query = makeQuery({
          filtros: [
            {field: 'vehiculo_marca_id', value: marca.id, operator: '='},
            {field: 'vehiculo_modelo_id', value: modelo.id, operator: '='}
          ]
        })
        const response = await this._vm.$axios.get(URL_VEHICULOS + query)
        commit("SET_KEY_VEHICULO_COMPATIBLE", {index: payload.index, key: "vehiculos", data: response.data.items})
      } catch (e) {
        console.error(e, "failed to load vehiculos")
      }
    },
    async getVehiculoCompatible({commit, dispatch, state}, payload) {
      try {
        const response = await this._vm.$axios(`${URL_VEHICULOS}/${payload.vehiculo_id}`)
        const {vehiculo_marca_id, vehiculo_modelo_id} = response.data
        let marca = state.marcasVehiculos.find(item => item.id === vehiculo_marca_id)
        commit("SET_KEY_VEHICULO_COMPATIBLE", {key: "marca", index: payload.index, data: marca})
        await dispatch("getModeloVehiculo", {data: marca, index: payload.index})
        let modelo = state.producto.vehiculosCompatibles[payload.index].modelos.find(item => item.id === vehiculo_modelo_id)
        commit("SET_KEY_VEHICULO_COMPATIBLE", {key: "modelo", index: payload.index, data: modelo})
        await dispatch("getVehiculos", {index: payload.index})
        let vehiculo = state.producto.vehiculosCompatibles[payload.index].vehiculos.find(item => item.id === payload.vehiculo_id)
        commit("SET_KEY_VEHICULO_COMPATIBLE", {key: "vehiculo", index: payload.index, data: vehiculo})
        commit("SET_KEY_VEHICULO_COMPATIBLE", {key: "esPrimario", index: payload.index, data: payload.esPrimario})
      } catch (e) {
        console.error(e, "failed to load vehiculos")
      }
    },
    async generarCodigo({state, commit}, payload) {
      let _codigo = []
      _codigo.push(state.producto.codigo.slice(0, 2))
      _codigo.push(state.producto.codigo.slice(2, 4))
      _codigo.push(state.producto.codigo.slice(4, 6))
      _codigo.push(state.producto.codigo.slice(6, 9))
      _codigo[payload.parte] = payload.dato
      if (payload.parte === 2 && !payload.producto_id) {
        const parcial = _codigo[0] + _codigo[1] + _codigo[2]
        const correlativo = await this._vm.$axios.get(URL_PRODUCTO_CORRELATIVO + parcial)
        return commit("SET_KEY_PRODUCTO", {key: "codigo", value: correlativo.data.codigo})
      }
      commit("SET_KEY_PRODUCTO", {key: "codigo", value: _codigo.join("")})
    },
    crearProducto({state}, payload) {
      const data = {
        ...state.producto,
        productoObservacion: state.producto.observacion,
        productoMedida: state.producto.medida,
        productoPais: state.producto.pais,
        numeroParte: state.producto.numero_parte,
        marca: state.producto.marcaProducto,
        usuario: {
          id: window.localStorage.usuario_id,
          nombre: window.localStorage.nombre
        },
        vehiculosCompatibles: state.producto.vehiculosCompatibles.map(item => ({
          productoId: state.producto.id,
          vehiculoId: item.vehiculo.id,
          vehiculoPrimario: item.esPrimario
        }))
      }
      return new Promise((resolve, reject) => {
        this._vm.$axios({data: data, method: payload.method, url: URL_PRODUCTO_MIRANDA})
          .then(resolve)
          .catch(error => {
            this._vm.$swal("Error", error.response.data, "error")
            reject(error)
          })
      })
    },
    async getProductoId({commit, dispatch, state}, payload) {
      try {
        commit("SET_LOADING", true)
        const query = await dispatch("crearQuery", payload)
        const response = await this._vm.$axios.get(URL_PRODUCTO_MIRANDA + query)
        const {marca, codigo, categoria, familia, vehiculos_compatibles, ...all} = response.data.items[0]
        const codigo_splice = codigo.substr(0, 2)
        await dispatch("fetchAll", {categoria, familia})
        commit("SET_PRODUCTO_EDIT", {
          ...response.data.items[0],
          marca: state.marcasVehiculos.find(m => m.codigo.toString() === codigo_splice.toString()),
          familia: state.familias.find(f => f.id === familia.id) || "",
          marcaProducto: state.marcasProducto.find(mp => mp.nombre === marca.nombre),
          medida: all.producto_medida,
          pais: all.producto_pais.toUpperCase(),
          observacion: all.producto_observacion.toUpperCase(),
          vehiculosCompatibles: vehiculos_compatibles.map(item => {
            return {
              ...item,
              marca: "",
              modelo: "",
              modelos: [],
              vehiculo: "",
              vehiculos: [],
              esPrimario: false
            }
          }) || [],
          grupo: all.grupo.toUpperCase(),
          imagenes: all.imagenes,
          descripcionWeb: all.descripcion_web,
          descripcionCortaWeb: all.descripcion_corta_web,
          nombreWeb: all.nombre_web,
          flagWeb: all.flag_web,
          precioWeb: all.precio_web
        })
        commit("SET_LOADING", false)
      } catch (e) {
        commit("SET_LOADING", false)
        console.log(e, "failed to load producto")
      }
    },
    async fetchAll({dispatch}, {categoria, familia}) {
      await dispatch("getMarcas")
      await dispatch("getMarcaProducto")
      await dispatch("getFamilias", {field: "categoriaId", value: categoria.id})
      await dispatch("getClasificacion", {field: "familiaId", value: familia.id})
    },
    async getImages({commit, dispatch}, payload) {
      try {
        const query = await dispatch("crearQuery", payload)
        const response = await this._vm.$axios.get(URL_PRODUCTO_MIRANDA + query)
        commit("SET_IMAGENES", response.data.items[0].imagenes)
      } catch (e) {
        console.error(e)
      }
    },
    ordenarArray(context, payload) {
      return payload.array.sort((a, b) => {
        if (a[payload.key] < b[payload.key]) return -1
        if (a[payload.key] > b[payload.key]) return 1
        return 0
      })
    },
    crearQuery(context, payload) {
      return makeQuery({
        filtros: [
          {field: payload.field, value: payload.value, operator: '='}
        ]
      })
    }
  },
  getters: {
    marcas: state => state.marcasVehiculos,
    categorias: state => state.categorias,
    familias: state => state.familias,
    clasificaciones: state => state.clasificaciones,
    marcasProducto: state => state.marcasProducto,
    vehiculosCompatibles: state => state.producto.vehiculosCompatibles,
    isLoading: state => state.isLoading,
    imagenes: state => state.producto.imagenes,
    isLoadingVehiculos: state => state.isLoadingVehiculos,
    producto: state => state.producto.producto
  }
}
